(function () {
    'use strict';

    angular
        .module('controlEditModule')
        .controller('ControlHistoryController', Controller);

    Controller.$inject = ['$scope', 'grcControlService'];

    function Controller($scope, grcControlService) {

        $scope.refreshData = function () {
            if (_.isUndefined($scope.control) || _.isNull($scope.control) || _.isUndefined($scope.control.ControlID)) {
                $scope.historicRecords = [];
                return;
            }

            grcControlService.getHistoricOnControl($scope.control.ControlID)
            .then(function (historicRecords) {
                $scope.historicRecords = historicRecords;
            });
        }
        $scope.refreshData();

        $scope.$on('refreshHistoricOnControl', function (event) {
            $scope.refreshData();
        });
    }
})();